<div class="authentication-bg min-vh-100">
  <div class="container">
    <div class="d-flex flex-column min-vh-100 px-2">
      <div class="row justify-content-center my-auto">
        <div class="col-md-6">
          <div class="card auth-cover-card mb-0 overflow-hidden">
            <div class="row g-0 card-height">
              <div class="col-lg-12 col-12">
                <div class="px-4 px-lg-5 py-4 py-xl-5 h-100 d-flex align-items-center justify-content-center">
                  <div class="w-100">
                    <div class="mb-4 text-center">
                      <a routerLink="/" class="d-block auth-logo">
                        <span class="env-dev-logo w-50 w-sm-100" [class.is-dev]="isDevEnv">
                          <img [src]="logoUrl" alt="" class="w-100" />
                        </span>
                      </a>
                    </div>
                    <router-outlet></router-outlet>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
